import { useNavigate } from "react-router-dom";
import AdnColumn from "../common/adnColumn/AdnColumn";
import { useTranslation } from "react-i18next";

const FollowUpEventsDashboard = ({ employeeFollowUpEventData }) => {
  const { t } = useTranslation();

  const FirstLastName = (name) => {
    const nameArray = name.split(" ");
    const firstName = nameArray[0];
    const lastNameLetter = nameArray[nameArray.length - 1];

    const firstLastName = firstName + " " + lastNameLetter;

    return firstLastName;
  };

  const getStatusTranslation = (status) => {
    const statusMapping = {
      Canceled: "canceled",
      Done: "done",
      "Not done": "notDone",
      "Not assigned": "notAssigned",
      Assigned: "assigned",
    };

    const normalizedStatus = status?.toString().toLowerCase();
    const mappingKey = Object.keys(statusMapping).find(
      (key) => key.toLowerCase() === normalizedStatus
    );

    return t(`common.status.${statusMapping[mappingKey] || status}`);
  };
  const employeeFollowUpEventsconfig = {
    height: 420,
    isGroup: true,
    xField: "userName",
    yField: "count",
    minColumnWidth: 30,
    maxColumnWidth: 40,
    dodgePadding:
      employeeFollowUpEventData && employeeFollowUpEventData.length > 2
        ? 2
        : null,
    seriesField: "status",
    color: ({ status }) => {
      if (status === "Canceled") {
        return "#9B2020";
      } else if (status === "Done") {
        return "#0FA958";
      } else if (status === "Not done") {
        return "#F3983B";
      } else return "#747985";
    },
    data: employeeFollowUpEventData
      ? employeeFollowUpEventData.userEmployeeFollowUpEvents?.map((item) => ({
          ...item,
          status: getStatusTranslation(item.status),
        }))
      : [],
    label: {
      position: "middle",
    },
    yAxis: {
      tickInterval: 1,
    },
    xAxis: {
      label: {
        style: {
          fontSize: 11,
        },
        autoRotate: false,
        autoHide: false,
        formatter: (name) => FirstLastName(name),
      },
    },
    scrollbar: {
      type: "horizontal",
      categorySize: 80,
    },
    interactions: [
      {
        type: "element-active",
        cfg: {
          showEnable: [
            { trigger: "element:mouseenter", action: "cursor:pointer" },
            { trigger: "element:mouseleave", action: "cursor:default" },
          ],
        },
      },
    ],
    columnStyle: {
      radius: 16,
    },
  };

  const navigate = useNavigate();

  return (
    <AdnColumn
      navigate={navigate}
      employeeFollowUpEventsconfig={employeeFollowUpEventsconfig}
    ></AdnColumn>
  );
};

export default FollowUpEventsDashboard;
